// src/pages/products/components/bulk/WarehouseSelector.jsx
import React, { useEffect, useState } from 'react';
import { Warehouse as WarehouseIcon, ChevronDown, Lock } from 'lucide-react';
import { getWarehouses } from '../../../../services/api/warehouses';
import styles from './WarehouseSelector.module.css';

const WarehouseSelector = ({ selectedWarehouse, onWarehouseChange, disabled }) => {
  const [warehouses, setWarehouses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadWarehouses = async () => {
      try {
        const response = await getWarehouses();
        setWarehouses(response || []);

        if (response && response.length === 1 && !selectedWarehouse) {
          onWarehouseChange(response[0]);
        }
      } catch (error) {
        console.error('Failed to load warehouses:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadWarehouses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <div className={styles.warehouseSelector}>
        <div className={styles.loading}>
          <div className={styles.spinner}></div>
          <span>Loading warehouses...</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.warehouseSelector}>
      <div className={styles.sectionHeader}>
        <WarehouseIcon size={20} />
        <h3>Opening Stock Warehouse</h3>
        {disabled && <Lock size={16} className={styles.lockIcon} />}
      </div>

      <div className={styles.selectWrapper}>
        <WarehouseIcon className={styles.selectIcon} size={18} />
        <select
          value={selectedWarehouse?.id || ''}
          onChange={(e) => {
            const warehouse = warehouses.find(w => w.id === parseInt(e.target.value));
            onWarehouseChange(warehouse || null);
          }}
          disabled={disabled}
          className={styles.select}
        >
          <option value="">No opening stock (skip)</option>
          {warehouses.map(warehouse => (
            <option key={warehouse.id} value={warehouse.id}>
              {warehouse.name}
            </option>
          ))}
        </select>
        <ChevronDown className={styles.selectArrow} size={18} />
      </div>

      {selectedWarehouse && (
        <div className={styles.selectedWarehouseInfo}>
          <div className={styles.warehouseName}>{selectedWarehouse.name}</div>
        </div>
      )}

      {disabled && (
        <div className={styles.disabledNote}>
          Warehouse cannot be changed after uploading file
        </div>
      )}
    </div>
  );
};

export default WarehouseSelector;
